import Axios from 'axios'

import type {
  TParentTaskDto,
  TSubTaskDto,
  TCreateTaskRequest,
  TCreateTaskResponse,
  TUpdateTaskRequest,
  TUpdateTaskResponse
} from '@homepal/api-contract'

import { TCustomizedMetric } from 'types/GlobalMetric'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

export type TTaskResponse = TParentTaskDto<TCustomizedMetric>

export type TSubTaskResponse = TSubTaskDto<TCustomizedMetric>

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/tasks`

export async function getAll() {
  return getWithRedirect<TTaskResponse[]>(URL)
}

export async function create(body: TCreateTaskRequest) {
  return Axios.post<TCreateTaskResponse<TCustomizedMetric>>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: TUpdateTaskRequest) {
  return Axios.patch<TUpdateTaskResponse<TCustomizedMetric>>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
